import { CustomerAddress, LoqateAddress, LoqateFullAddress } from '@models';

export interface IState {
  id: string;
  value: string;
}

export const AU_STATES: IState[] = [
  { id: 'ACT', value: 'Australian Capital Territory' },
  { id: 'NSW', value: 'New South Wales' },
  { id: 'NT', value: 'Northern Territory' },
  { id: 'QLD', value: 'Queensland' },
  { id: 'SA', value: 'South Australia' },
  { id: 'TAS', value: 'Tasmania' },
  { id: 'VIC', value: 'Victoria' },
  { id: 'WA', value: 'Western Australia' },
];

export const VALID_TIMEZONES = [
  { id: 'ACT', value: 'Australia/Canberra' },
  { id: 'NSW', value: 'Australia/Sydney' },
  { id: 'NT', value: 'Australia/Darwin' },
  { id: 'QLD', value: 'Australia/Brisbane' },
  { id: 'SA', value: 'Australia/Adelaide' },
  { id: 'TAS', value: 'Australia/Hobart' },
  { id: 'VIC', value: 'Australia/Melbourne' },
  { id: 'WA', value: 'Australia/Perth' },
];

export const LoqateFullAddressInitialState: LoqateFullAddress = {
  fullAddress: '',
  id: '',
  attributes: {},
};

export const LoqateInitialState: LoqateAddress = {
  fullAddress: '',
  country: '',
  postcode: '',
  street2: '',
  streetNumber: '',
  postal: '',
  postalType: '',
  postalNumber: '',
  buildingName: '',
  subdwelling: '',
  eid: '',
  lotNumber: '',
  flatUnitNumber: '',
  flatUnitType: '',
  floorLevelNumber: '',
  floorLevelType: '',
  streetSuffix: '',
  street: '',
  streetType: '',
  streetName: '',
  attributes: {},
  id: '',
  exception: '',
  state: '',
  locality: '',
};

export const postcodeError = 'This postcode is not within the serviceable area of Jimmy Brings.';

export interface AddressFormData extends CustomerAddress {
  longitude: string;
  latitude: string;
  gnafid?: string;
}
